export const API_CALL = Symbol('grdp/api-call');

export class APIResponseError extends Error {
  constructor(res) {
    super(res.statusText);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, APIResponseError);
    }

    this.res = res;
    this.message = res.statusText;
    this.status = res.status;
    this.date = new Date();
  }
}

export default (api) => () => (next) => (action) => {
  if (!action) {
    return null;
  }
  if (!action.meta || !action.meta[API_CALL]) {
    return next(action);
  }
  const method = action.meta[API_CALL];
  const args = action.payload || [];
  const request = api[method](...args)
    // .then(errorHandler)
    .then((res) => Promise.all([res.json(), Promise.resolve(res)]))
    .then(([data, res]) => {
      if (res.status !== 200) {
        return next({
          type: `${action.type}`,
          payload: { status: res.status, message: data.message },
          error: true
        });
      }
      return next({
        type: `${action.type}`,
        payload: data,
        meta: {
          headers: res.headers
        }
      });
    })
    .catch((err) =>
      next({
        type: `${action.type}`,
        payload: { code: err, message: 'An error happened, please try again.' },
        error: true
      })
    );
  next({
    type: `${action.type}_PENDING`,
    payload: { request },
    isFetching: true,
    error: false,
    meta: {
      method,
      args
    }
  });
  return request; // @todo return next instead to force using central state
};
